<template>
  <div class="add-play-component">
    <ValidationObserver
      ref="addPlayObserver"
      tag="form"
      @submit.prevent="onSubmit"
    >
      <a-row :style="{ margin: 0 }">
        <a-col :xs="24" :sm="24" :md="24" :lg="24">
          <a-space :size="100" align="end">
            <Input
              :style="{ width: '80%' }"
              :key="'inputCount' + keyCount"
              class="input-play"
              v-model.trim="form.numbers"
              :placeholder="'JUGADA'"
              inputmode="numeric"
              :vid="`numbers`"
              :ref="`numbers`"
              :rules="validRules"
              :label="labels.form.numbers.label"
              v-themask="maskText"
              :max-length="8"
              :formItem="{
                style: {
                  marginBottom: 0,
                },
              }"
              v-on:keyup.enter.native="focusAmount"
              @focus="setFocus('play')"
              @input="validateToFocusAmount"
            />
            <Input
              class="input-amount"
              v-model="form.amount"
              :placeholder="labels.form.amount.placeholder"
              vid="amount"
              ref="amount"
              :label="labels.form.amount.label"
              :max="99999999999"
              :min="0"
              :rules="'required'"
              :precision="0"
              v-on:keyup.enter.native="onSubmit"
              :formItem="{
                style: {
                  marginBottom: 0,
                },
              }"
              @focus="setFocus('amount')"
            />
            <a-button type="primary" :class="['form-button']" @click="onSubmit">
              <span v-if="!isMobile">{{ labels.form.add }}</span>
              <a-icon type="plus" />
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import Input from "./core/VeeValidateForm/Input.vue";
import * as _ from "lodash";
import { mask } from "vue-the-mask";
import { nextTick } from "vue";
import { PLAY_TYPES } from "../utils/utils";
import { isEmpty } from "lodash";

const initialState = {
  numbers: "",
  amount: undefined,
};

export default {
  name: "AddPlayComponent",
  components: {
    ValidationObserver,
    Input,
  },
  directives: { themask: mask },
  emits: ["submit"],
  props: {
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    labels: {
      type: Object,
      default: () => ({}),
    },
    isSuperpale: {
      type: Boolean,
      default: false,
    },
    superPaleGenerated: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: String,
      default: "",
    },
    numbers: {
      type: String,
      default: "",
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    playTypeFilter: {
      type: String,
      default: PLAY_TYPES.AUTO,
    },
    matchType: {
      type: String,
      default: "straight",
    },
  },
  data: () => ({
    form: _.cloneDeep(initialState),
    keyCount: 0,
  }),
  created() {
    if (!_.isEmpty(this.defaultData)) {
      Object.assign(this.form, this.defaultData);
    }
  },
  watch: {
    amount(value) {
      this.form.amount = parseInt(value);
    },
    numbers(value) {
      this.form.numbers = value;
      this.keyCount++;
    },
  },
  computed: {
    validRules() {
      if (this.superPaleGenerated) {
        return "required|validPlayNumber|validPale";
      } else {
        switch (this.playTypeFilter) {
          case PLAY_TYPES.QUINIELA:
            return "required|validPlayNumber|validPlay";
          case PLAY_TYPES.PALE:
            return "required|validPlayNumber|validPale";
          case PLAY_TYPES.TRIPLET:
            return "required|validPlayNumber|validPlay";
          case PLAY_TYPES.PICK_3:
            return "required|validPlayNumberPick|validPick3";
          case PLAY_TYPES.PICK_4:
            return "required|validPlayNumberPick|validPick4";
          case PLAY_TYPES.AUTO:
          default:
            return "required|validPlayNumber|validPlay";
        }
      }
    },
    maskText() {
      switch (this.playTypeFilter) {
        case PLAY_TYPES.SUPERQUINIELA:
        case PLAY_TYPES.QUINIELA:
          return ["##"];
        case PLAY_TYPES.PALE:
          return ["##-##"];
        case PLAY_TYPES.TRIPLET:
          return ["##-##-##"];
        case PLAY_TYPES.PICK_3:
          return ["#-#-#"];
        case PLAY_TYPES.PICK_4:
          return ["#-#-#-#"];
        case PLAY_TYPES.AUTO:
        default:
          return ["##", "##-##", "##-##-##"];
      }
    },
    showAddButton() {
      return (
        this.total === 0 ||
        !isEmpty(this.form.amount) ||
        !isEmpty(this.form.numbers)
      );
    },
    showPayButton() {
      return (
        this.total > 0 &&
        isEmpty(this.form.amount) &&
        isEmpty(this.form.numbers)
      );
    },
  },
  methods: {
    handleSubmit() {
      this.$emit("handleSubmit");
    },
    setFocus(value) {
      this.$emit("setfocus", value);
    },
    playType(numbers) {
      const numbersArray = numbers.split("-");
      if (numbersArray.length === 2) {
        return PLAY_TYPES.PALE;
      } else if (numbersArray.length === 3) {
        let tripleta = false;
        numbersArray.forEach((element) => {
          if (element.length > 1) {
            tripleta = true;
          }
        });

        if (tripleta) {
          return PLAY_TYPES.TRIPLET;
        } else {
          return PLAY_TYPES.PICK_3;
        }
      } else if (numbersArray.length === 4) {
        return PLAY_TYPES.PICK_4;
      } else {
        if (this.playTypeFilter === PLAY_TYPES.SUPERQUINIELA) {
          return PLAY_TYPES.SUPERQUINIELA;
        }
        return PLAY_TYPES.QUINIELA;
      }
    },
    onSubmit() {
      if (this.form.amount && typeof this.form.amount !== "number") {
        try {
          this.form.amount = parseInt(this.form.amount);
        } catch (error) {
          return;
        }
      }

      const playType = this.playType(this.form.numbers);
      if ((playType === "pick3" || playType === "pick4") && !this.matchType) {
        return;
      }
      this.$refs.addPlayObserver.validate().then((success) => {
        if (success) {
          this.$emit("submit", {
            ..._.cloneDeep(this.form),
            type: this.superPaleGenerated
              ? PLAY_TYPES.SUPERPALE
              : this.isSuperpale
              ? PLAY_TYPES.SUPERPALE
              : playType,
            straight_match: this.matchType === "straight" ? true : false,
            box_match: this.matchType === "box" ? true : false,
          });
          this.$refs.addPlayObserver.reset();
          this.form = {
            ..._.cloneDeep(initialState),
            amount: this.form.amount,
          };
          this.focusNumbers();
          this.$emit("onclean");
        }
      });
    },
    focusNumbers() {
      nextTick(() => {
        this.$refs.numbers.$el.querySelector("input").focus();
      });
    },
    focusAmount() {
      nextTick(() => {
        this.$refs.amount.$el.querySelector("input").focus();
      });
    },
    validateToFocusAmount(value) {
      if (!value || value?.length < 2) return;

      const playType = this.playType(value);

      switch (this.playTypeFilter) {
        case PLAY_TYPES.QUINIELA:
        case PLAY_TYPES.SUPERQUINIELA:
          if (
            (playType === PLAY_TYPES.QUINIELA ||
              playType === PLAY_TYPES.SUPERQUINIELA) &&
            value.length === 2
          ) {
            this.focusAmount();
          }
          break;
        case PLAY_TYPES.PALE:
          if (playType === PLAY_TYPES.PALE && value.length === 5) {
            this.focusAmount();
          }
          break;
        case PLAY_TYPES.TRIPLET:
          if (playType === PLAY_TYPES.TRIPLET && value.length === 8) {
            this.focusAmount();
          }
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.add-play-component {
  .form-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 10px;
    display: block;
  }

  .ant-space {
    > :first-child {
      width: 80% !important;
    }

    &.ant-space-horizontal {
      width: 100%;
    }

    .ant-space-item {
      margin-right: 4px !important;
    }

    > :last-child {
      margin-right: 0 !important;

      button {
        background-color: var(--btn-bg-secondary);
        border-color: var(--btn-bc-secondary);
        color: var(--btn-text-secondary);
        margin-bottom: 7px;
        border-radius: 0;
        @media screen and (max-width: $screen-mobile) {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
